import { PlanTrailActionContext, getMap } from "./types";
import mapboxgl from "mapbox-gl";

export const poiInteractionsActions = {
  setupPOIInteractions({ }: PlanTrailActionContext) {
    const map = getMap();
    if (!map) return;

    // Find all POI layers
    const style = map.getStyle();
    if (!style || !style.layers) return;

    // Get all POI-related layers
    const poiLayers = style.layers
      .filter(layer => layer.source && layer.source.includes('poi'))
      .map(layer => layer.id);

    // Add hover and click handlers for each POI layer
    poiLayers.forEach(layerId => {
      // Remove existing handlers to avoid duplicates
      map.off('mouseenter', layerId);
      map.off('mouseleave', layerId);
      map.off('click', layerId);

      // Add cursor change on hover
      map.on('mouseenter', layerId, () => {
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mouseleave', layerId, () => {
        map.getCanvas().style.cursor = '';
      });

      // Click handler is already handled in mapClicked action
      // which checks for POI clicks and shows the dialog
    });
  }
};